import { createSlice } from '@reduxjs/toolkit';
import {
  SearchStatusMasterResponse,
  SearchStatusMasterRecord,
  DetailStatusMasterResponse,
  SearchStatusMasterRequest,
  DetailStatusMasterRequest,
  UpdateStatusMasterRequest,
  DeleteStatusMasterRequest,
} from 'api-types/src/types/status-master'
import i18n from 'i18n/i18n';

export type StatusMasterState = {
  loading: boolean;
  loadingExportExcel: boolean;
  filterSearchTotal: number;
  filterInitialSearchData: SearchStatusMasterRecord[];
  filterSearchData: SearchStatusMasterRecord[];
  sortSelected: string;
  sortDirection: string;
  message: string;
  statusDetail: DetailStatusMasterResponse | {};
  success: boolean;
};

const initialState: StatusMasterState = {
  loading: false,
  loadingExportExcel: false,
  filterSearchTotal: 0,
  filterInitialSearchData: [],
  filterSearchData: [],
  sortSelected: '',
  sortDirection: '',
  message: '',
  statusDetail: {},
  success: false,
};

export const statusMasterSlice = createSlice({
  name: 'statusMaster',
  initialState,
  reducers: {
    filterStatus: (state, action: {payload: SearchStatusMasterRequest}) => {
      state.loading = true;
      state.message = '';
    },
    filterStatusSuccess: (state, action: {payload: SearchStatusMasterResponse}) => {
      state.loading = false;
      state.filterInitialSearchData = action.payload?.records;
      state.filterSearchData = action.payload?.records;
      if (!action.payload?.total) {
        state.message = i18n.t('message.common.0001');
      }
      state.filterSearchTotal = action.payload?.total;
      state.success = false;
    },
    filterStatusFailure: (state) => {
      state.loading = false;
    },
    getDetailStatus: (state, action: {payload: DetailStatusMasterRequest}) => {
      state.loading = true;
    },
    getDetailStatusSuccess: (state, action: {payload: DetailStatusMasterResponse}) => {
      state.loading = false;
      state.statusDetail = action.payload;
    },
    getDetailStatusFailure: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },
    setLoadingExportExcel: (state, action: {payload: boolean}) => {
      state.loadingExportExcel = action.payload;
    },
    registerStatus: (state, action: {payload: UpdateStatusMasterRequest}) => {
      state.loading = true;
      state.success = false;
    },
    registerStatusSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    registerStatusFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload?.message;
    },
    updateStatus: (state, action: {payload: UpdateStatusMasterRequest}) => {
      state.loading = true;
      state.success = false;
    },
    updateStatusSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    updateStatusFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload?.message;
    },
    deleteStatus: (state, action: {payload: DeleteStatusMasterRequest}) => {
      state.loading = true;
      state.success = false;
    },
    deleteStatusSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    deleteStatusFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload.message;
    },
    cleanDataStatus: (state) => {
      state.statusDetail = {};
    },
    cleanData: (state) => {
      return {
        ...initialState,
      };
    },
  },
});

export const {
  filterStatus,
  filterStatusSuccess,
  filterStatusFailure,
  setLoadingExportExcel,
  getDetailStatus,
  getDetailStatusSuccess,
  getDetailStatusFailure,
  registerStatus,
  registerStatusSuccess,
  registerStatusFailure,
  updateStatus,
  updateStatusSuccess,
  updateStatusFailure,
  deleteStatus,
  deleteStatusSuccess,
  deleteStatusFailure,
  cleanDataStatus,
  cleanData,
} = statusMasterSlice.actions;

export default statusMasterSlice.reducer;
